"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledCardSectionContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _defaultTheme = _interopRequireDefault(require("../../../defaultTheme"));

var _CardSectionContext = _interopRequireDefault(require("../CardSectionContext"));

var _Slide = _interopRequireWildcard(require("../../../utils/Slide"));

var _mediaQuery = _interopRequireDefault(require("../../../utils/mediaQuery"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var hasPaddingTop = function hasPaddingTop(_ref) {
  var expandable = _ref.expandable,
      expanded = _ref.expanded,
      visible = _ref.visible;
  return expanded || visible || !expandable;
};

var StyledCardSectionContent = _styledComponents.default.div.withConfig({
  displayName: "CardSectionContent__StyledCardSectionContent",
  componentId: "sc-1mj8dfx-0"
})(["font-family:", ";font-size:", ";line-height:", ";color:", ";border-top:", ";padding-top:", ";transition:padding ", " linear,border-top ", " linear;", " ", "{max-height:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.fontSizeTextNormal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.lineHeightTextNormal;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.colorTextPrimary;
}, function (_ref6) {
  var theme = _ref6.theme,
      expanded = _ref6.expanded;
  return expanded ? "1px solid ".concat(theme.orbit.paletteCloudNormal) : "0px solid ".concat(theme.orbit.paletteCloudNormal);
}, function (_ref7) {
  var theme = _ref7.theme,
      expandable = _ref7.expandable,
      expanded = _ref7.expanded,
      visible = _ref7.visible;
  return hasPaddingTop({
    expandable: expandable,
    expanded: expanded,
    visible: visible
  }) && theme.orbit.spaceMedium;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.orbit.durationFast;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.orbit.durationFast;
}, _mediaQuery.default.desktop((0, _styledComponents.css)(["padding-top:", ";"], function (_ref10) {
  var theme = _ref10.theme,
      expandable = _ref10.expandable,
      expanded = _ref10.expanded,
      visible = _ref10.visible;
  return hasPaddingTop({
    expandable: expandable,
    expanded: expanded,
    visible: visible
  }) && theme.orbit.spaceLarge;
})), _Slide.StyledSlide, function (_ref11) {
  var expandable = _ref11.expandable,
      visible = _ref11.visible;
  return expandable && visible && "none";
});

exports.StyledCardSectionContent = StyledCardSectionContent;
StyledCardSectionContent.defaultProps = {
  theme: _defaultTheme.default
};

var withConsumer = function withConsumer(CardSection) {
  return function (_ref12) {
    var children = _ref12.children,
        visible = _ref12.visible;
    return _react.default.createElement(_CardSectionContext.default.Consumer, null, function (_ref13) {
      var expandable = _ref13.expandable,
          expanded = _ref13.expanded;
      return _react.default.createElement(CardSection, {
        expandable: expandable,
        expanded: expanded,
        visible: visible
      }, children);
    });
  };
};

var CardSectionContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CardSectionContent, _React$Component);

  function CardSectionContent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CardSectionContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CardSectionContent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      contentHeight: 0
    });

    _defineProperty(_assertThisInitialized(_this), "node", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "setHeight", function () {
      var _this$node$current;

      _this.setState({
        contentHeight: (_this$node$current = _this.node.current) === null || _this$node$current === void 0 ? void 0 : _this$node$current.clientHeight
      });
    });

    return _this;
  }

  _createClass(CardSectionContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var expandable = this.props.expandable;

      if (expandable) {
        window.addEventListener("resize", this.setHeight);
        setTimeout(this.setHeight, 10);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var expandable = this.props.expandable;

      if (expandable) {
        if (prevState.contentHeight !== this.state.contentHeight || prevProps.children !== this.props.children) {
          setTimeout(this.setHeight, 10);
        }

        if (prevProps.expanded !== this.props.expanded) {
          // Calculate height on expand - for dynamic components like TripSector
          this.setHeight();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.setHeight);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          expanded = _this$props.expanded,
          expandable = _this$props.expandable,
          visible = _this$props.visible;
      return _react.default.createElement(StyledCardSectionContent, {
        expanded: expanded,
        expandable: expandable,
        visible: visible,
        contentHeight: this.state.contentHeight
      }, expandable ? _react.default.createElement(_Slide.default, {
        maxHeight: this.state.contentHeight,
        expanded: expanded
      }, _react.default.createElement("div", {
        ref: this.node
      }, children)) : _react.default.createElement("div", {
        ref: this.node
      }, children));
    }
  }]);

  return CardSectionContent;
}(_react.default.Component);

var DecoratedComponent = withConsumer(CardSectionContent);
DecoratedComponent.displayName = "CardSectionContent";
var _default = DecoratedComponent;
exports.default = _default;